import styled from 'styled-components'

import { ManWithMagnifyingGlass } from '@application/Interfaces/Images/ManWithMagnifyingGlass'

export const Header = styled.div`
    padding: 40px 0;
`

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 90vh;
    min-height: calc(100vh - 130px);
`

export const NotFoundImage = styled(ManWithMagnifyingGlass)`
    max-width: 100%;
    height: auto;
`

export const Content = styled.div`
    padding: 20px 0;
    text-align: center;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 80px 0;
    }
`

export const Title = styled.div`
    ${(props) => props.theme.typo.displayM};
    ${(props) => props.theme.fontWeight.bold};
    color: ${(props) => props.theme.color.p500};
    margin-bottom: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXL};
    }
`

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g600};

    a {
        ${(props) => props.theme.fontWeight.medium};
        color: ${(props) => props.theme.color.p500};
    }

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.bodyL};
    }
`
